import React from 'react';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    console.error('🔴 Component Error:', error);
    console.error('🔴 Error Info:', errorInfo);
    console.error('🔴 Component Stack:', errorInfo.componentStack);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div style={{ padding: 20, border: '2px solid red' }}>
          <h2>Component Error</h2>
          <pre>{this.state.error?.toString()}</pre>
          <p>Check console for component stack trace</p>
        </div>
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary;